import "core-js/modules/es.promise.finally";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import * as React from "react";
import { Component } from "react";
import { WaitingSpinner } from "../components/waiting-spinner";
export var ContactForm = /*#__PURE__*/function (_Component) {
  _inheritsLoose(ContactForm, _Component);

  function ContactForm(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.state = {
      submitted: false,
      submitting: false
    };
    return _this;
  }

  var _proto = ContactForm.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$state = this.state,
        submitted = _this$state.submitted,
        submitting = _this$state.submitting;
    return /*#__PURE__*/React.createElement("div", null, !submitted && /*#__PURE__*/React.createElement(WaitingSpinner, {
      waiting: submitting
    }, /*#__PURE__*/React.createElement("form", {
      className: "form narrow center",
      action: "https://formspree.io/mgenoaqo",
      method: "POST",
      onSubmit: function onSubmit(event) {
        return _this2.handleSubmit(event);
      }
    }, /*#__PURE__*/React.createElement("h2", null, "How can I help you?"), /*#__PURE__*/React.createElement("div", {
      className: "field"
    }, /*#__PURE__*/React.createElement("div", {
      className: "control"
    }, /*#__PURE__*/React.createElement("input", {
      className: "input",
      placeholder: "Enter your name",
      type: "text",
      name: "name"
    }))), /*#__PURE__*/React.createElement("div", {
      className: "field"
    }, /*#__PURE__*/React.createElement("div", {
      className: "control"
    }, /*#__PURE__*/React.createElement("input", {
      className: "input",
      placeholder: "Enter your email",
      type: "email",
      name: "email",
      required: true
    }))), /*#__PURE__*/React.createElement("div", {
      className: "field"
    }, /*#__PURE__*/React.createElement("div", {
      className: "control"
    }, /*#__PURE__*/React.createElement("textarea", {
      className: "textarea",
      placeholder: "Explain how we can help you",
      name: "text",
      required: true
    }))), /*#__PURE__*/React.createElement("div", {
      className: "field"
    }, /*#__PURE__*/React.createElement("div", {
      className: "control"
    }, /*#__PURE__*/React.createElement("button", {
      className: "button is-primary is-fullwidth",
      type: "submit"
    }, "Send"))))), submitted && this.props.children);
  };

  _proto.handleSubmit = function handleSubmit(event) {
    var _this3 = this;

    var form = event.target;
    var data = new FormData(form);
    this.setState({
      submitting: true
    });
    event.preventDefault();
    fetch(form.action, {
      method: form.method,
      body: data
    }).finally(function () {
      return _this3.setState({
        submitting: false,
        submitted: true
      });
    });
  };

  return ContactForm;
}(Component);